import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import es from '@/i18n/es.ts';
import pt from '@/i18n/pt.ts';
import en from '@/i18n/en.ts';
import en_us from '@/i18n/en-us.ts';


const i18n = new VueI18n({
    locale: process.env.VUE_APP_DEFAULT_LANGUAGE,
    fallbackLocale: 'en',
    messages: {
        en, es,pt,en_us
    }
})

export {i18n};
